import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import {
  provideRouter,
  RouteReuseStrategy,
  withComponentInputBinding,
  withRouterConfig,
} from '@angular/router';
import { HttpClient, provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { TranslateCompiler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { provideMarkdown } from 'ngx-markdown';

import { routes } from './app.routes';
import { MAT_PAGINATOR_DEFAULT_OPTIONS } from '@angular/material/paginator';
import { UiConstants } from 'core/constants';
import { authInterceptor } from 'angular-auth-oidc-client';
import { httpErrorInterceptorFn } from 'error/http-error-interceptor';
import { IntlMessageFormatCompiler } from 'app/intl-message-format.compiler';
import { tenantContextInterceptorFn } from 'app/auth/tenant-context.interceptor';
import { DashboardRouteReuseStrategy } from 'app/dashboard-route-reuse.strategy';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material/dialog';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslationLanguageService } from 'app/i18n/translation-language.service';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/catalogs/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAppInitializer(() => inject(TranslationLanguageService).initialize()),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({
        onSameUrlNavigation: 'reload',
      }),
    ),
    {
      provide: RouteReuseStrategy,
      useClass: DashboardRouteReuseStrategy,
    },
    provideHttpClient(
      withXhr(),
      withInterceptors([authInterceptor(), tenantContextInterceptorFn, httpErrorInterceptorFn]),
    ),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
        compiler: {
          provide: TranslateCompiler,
          useClass: IntlMessageFormatCompiler,
        },
      }),
    ),
    provideMarkdown(),
    // Angular Material
    {
      provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
      useValue: {
        pageSize: UiConstants.DEFAULT_PAGE_SIZE,
        pageSizeOptions: [
          UiConstants.DEFAULT_PAGE_SIZE,
          UiConstants.DEFAULT_PAGE_SIZE * 5,
          UiConstants.DEFAULT_PAGE_SIZE * 10,
        ],
        showFirstLastButtons: true,
      },
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      useValue: { autoFocus: false },
    },
  ],
};
